import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import * as uuid from 'uuid';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-apppermit-edit',
  templateUrl: './apppermit-edit.component.html',
  styleUrls: ['./apppermit-edit.component.css'],
   providers: [MessageService,ConfirmationService]
})
export class ApppermitEditComponent implements OnInit {

  @ViewChild('maintableAttrib') maintableAttrib:any;
  loadingusers:boolean=false;
  action:string='';
  showDialog:boolean=false;
  nomeApp:string='';
  app_id:number=0;
  permesso:any={
    name:'',
    description:'',
    allUsers:false,
    allUsersDipendenti:false,
    allUsersDepts:false,
    userlist:false,
    users:[],
    uffici:[],
    attributi:[]
  };
  utentiList:any[]=[];
  selectedUsers:any[]=[];
  ufficiList:any[]=[];
  struttureList:any[]=[];
  roleList:any[]=[];
  searchName:string='';
  searchStruttura:number=0;
  searchRuolo:number=0;
   
  

  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute
  ) { }
  
  ngOnInit(): void {
      this.nomeApp=this.route.snapshot.paramMap.get('nomeapp');
      this.action=this.route.snapshot.paramMap.get('action');
      this.app_id=parseInt(this.route.snapshot.paramMap.get('app_id'));
      
      let uff=this.apiService.get('organizationchart/getcdcperstrutture',{});
      let roles=this.apiService.get('organizationchart/get_ruoli',{});
      let strutture=this.apiService.get('organizationchart/get_strutture',{});

      forkJoin([ strutture,roles,uff]).subscribe(data => {
        this.roleList=data[1].Result;
        this.roleList.unshift({value:0,label:''});
        this.struttureList=data[0].Result;
        this.struttureList.unshift({value:0,label:''});
        this.ufficiList=data[2].Result;
        this.ufficiList.unshift({value:0,label:''});
      });
      if (this.route.snapshot.paramMap.get('id')) {
       
        this.apiService.get('organizationchart/permits_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data => {
          this.permesso=data.Result[0];
          this.permesso.allUsers=this.permesso.allUsers==0 ? false:true;
          this.permesso.allUsersDipendenti=this.permesso.allUsersDipendenti==0 ? false:true;
          this.permesso.allUsersDepts=this.permesso.allUsersDepts==0 ? false:true;
          this.permesso.userlist=this.permesso.userlist==0 ? false:true;

        });

      }

          


  }

  salva(){
    this.permesso.app_id=this.app_id;
    
    this.apiService.get('organizationchart/permit_update',this.permesso).subscribe((data:any) => {
          this.addSingle('success', 'Success', 'Record aggiornato');
    });

  }

  delete(){

  }

  deleteUser(user:any){

  }

  nuovoAttributo(){
      const newS:any = {
          id:uuid.v4(),
          name: '',
          parametro:'',
          operatore:'=',
          valore:''
        };
     
        this.permesso.attributi.unshift(newS);
        this.maintableAttrib.editingRowKeys[newS[this.maintableAttrib.dataKey]] = true;
    
  }
  
  nuovoutente(){
    this.selectedUsers=[];
    this.utentiList=[];
    this.searchName='';
    this.searchRuolo=0;
    this.searchStruttura=0;
    this.showDialog=true;
  }

  ricerca(){

    if(this.searchName=='' && this.searchRuolo==0 && this.searchStruttura==0){
      return;
    }

    let params:any={};
    if(this.searchName){
      params.username= this.searchName;
    }
    if(this.searchStruttura){
      params.struttura= this.searchStruttura;
    }
    if(this.searchRuolo){
      params.role= this.searchRuolo;
    }
   
    this.apiService.get('organizationchart/get_users',params).subscribe(data => {
      this.utentiList=data.Result;
   });
  }

  caricaUtenti(){
    this.showDialog=false;

    this.loadingusers=true;
    this.selectedUsers.forEach((u)=>{
      let isPresent=false;
      this.permesso.users.forEach((t)=>{
        if(u.id=t.id){
          isPresent=true;
        }
      });
   //   if(!isPresent){
        this.permesso.users.push(u);
     // }
    });
 console.log(this.permesso.users);
    this.loadingusers=false;
  }
  
  onRowEditSave(ev:any){
    
  }
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  

}
